import { apiPaths, getApiPath, httpStatus } from '../../constants'
import { Api } from '../../middlewares'
import { Logger, LoggerTypes } from '../../utils'

// -- GET
export const GET_GLOBAL_RESOURCES_SUCCESS = 'GET_GLOBAL_RESOURCES_SUCCESS'
export const GET_GLOBAL_RESOURCES_FAILURE = 'GET_GLOBAL_RESOURCES_FAILURE'

// -- CREATE
export const CREATE_GLOBAL_RESOURCE_SUCCESS = 'CREATE_GLOBAL_RESOURCE_SUCCESS'
export const CREATE_GLOBAL_RESOURCE_FAILURE = 'CREATE_GLOBAL_RESOURCE_FAILURE'

// -- UPDATE
export const UPDATE_GLOBAL_RESOURCE_SUCCESS = 'UPDATE_GLOBAL_RESOURCE_SUCCESS'
export const UPDATE_GLOBAL_RESOURCE_FAILURE = 'UPDATE_GLOBAL_RESOURCE_FAILURE'

// -- DELETE
export const DELETE_GLOBAL_RESOURCE_SUCCESS = 'DELETE_GLOBAL_RESOURCE_SUCCESS'
export const DELETE_GLOBAL_RESOURCE_FAILURE = 'DELETE_GLOBAL_RESOURCE_FAILURE'

// -- SELECT
export const SELECT_GLOBAL_RESOURCES = 'SELECT_GLOBAL_RESOURCES'

// ---------------------------------------------------------------------------

/**
 * GET the list of all global resources attributes.
 *
 * @returns {Promise<array<object>>}
 */
export const getGlobalResources = () => async (dispatch) => {
  const path = apiPaths.GLOBAL_RESOURCE_LIST
  const api = new Api(path)
  const result = await api.get()

  Logger.trace(LoggerTypes.ACTION, '[ACTION] globalResourcesActions.getGlobalResources()', { path, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: GET_GLOBAL_RESOURCES_SUCCESS,
      data: result.data.items || []
    })
  }
  return dispatch({
    type: GET_GLOBAL_RESOURCES_FAILURE,
    data: result.data
  })
}

/**
 * CREATE a new global resource attribute.
 *
 * @param {object} newResource New resource attribute object to create
 * @returns {Promise<object>}
 */
export const createGlobalResource = (newResource) => async (dispatch) => {
  const path = apiPaths.GLOBAL_RESOURCE_CREATE
  const api = new Api(path)
  const result = await api.create(newResource)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] globalResourcesActions.createGlobalResource()', {
    path,
    newResource,
    result
  })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: CREATE_GLOBAL_RESOURCE_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: CREATE_GLOBAL_RESOURCE_FAILURE,
    data: result.data
  })
}

/**
 * UPDATE a specific global resource attribute based on its resource ID
 *
 * @param {object} newResource Object to set instead of the previous one.
 * @param {uui} rid Resource ID to update
 * @returns {Promise<object>}
 */
export const updateGlobalResource = (newResource, rid) => async (dispatch) => {
  const path = getApiPath(apiPaths.GLOBAL_RESOURCE_UPDATE, { rid })
  const api = new Api(path)
  const result = await api.update(newResource)
  Logger.trace(LoggerTypes.ACTION, '[ACTION] globalResourcesActions.updateGlobalResource()', {
    path,
    newResource,
    result
  })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: UPDATE_GLOBAL_RESOURCE_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: UPDATE_GLOBAL_RESOURCE_FAILURE,
    data: result.data
  })
}

/**
 * DELETE a specific global resource attribute based on its resource ID.
 *
 * @param {uuid} rid Resource ID to delete.
 * @returns {Promise<uuid>}
 */
export const deleteGlobalResource = (rid) => async (dispatch) => {
  const path = getApiPath(apiPaths.GLOBAL_RESOURCE_DELETE, { rid })
  const api = new Api(path)
  const result = await api.delete()

  Logger.trace(LoggerTypes.ACTION, '[ACTION] globalResourcesActions.deleteGlobalResource()', { path, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: DELETE_GLOBAL_RESOURCE_SUCCESS,
      data: rid
    })
  }
  return dispatch({
    type: DELETE_GLOBAL_RESOURCE_FAILURE,
    data: result.data
  })
}

/**
 * SELECT a list of global resource UUID.
 *
 * @param {array<uuid>} data Array of global resource UUID to select.
 * @returns {Promise<string>}
 */
export const selectListGlobalResources = (data) => async (dispatch) => {
  Logger.trace(LoggerTypes.ACTION, '[ACTION] globalResourcesActions.selectListGlobalResources()', { data })
  return dispatch({
    type: SELECT_GLOBAL_RESOURCES,
    data
  })
}
